<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div>
      <el-form inline ref="listForm" :model="listForm" label-width="90px">
        <el-form-item label="设备型号">
          <el-select
            v-model="listForm.equipmentVersion"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="v in typeListArr"
              :key="v.id"
              :label="v.equipmentVersion"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input
            v-model="listForm.equipmentNum"
            placeholder="请输入设备编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="联网状态">
          <el-select v-model="listForm.status" placeholder="全部" clearable>
            <el-option label="在线" value="1"></el-option>
            <el-option label="离线" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            class="mgr-30 mgl-50"
            type="primary"
            @click="getshebeiList()"
            >查询</el-button
          >
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="heng"></div>
    <btns @exec="exec"></btns>

    <!-- 导入弹框 -->
    <el-dialog title="导入" :visible.sync="dialogVisible" width="30%">
      <el-select v-model="importType" placeholder="请选择类型" class="mgb-30">
        <el-option label="mcu" value="2"></el-option>
      </el-select>
      <el-upload
        v-if="importType"
        ref="upload"
        :action="'#'"
        :limit="1"
        :multiple="false"
        :auto-upload="false"
        accept=".xls,.xlsx"
        :file-list="fileList"
        :http-request="uploadFile"
        :on-change="fileChange"
        :on-exceed="handleExceed"
        :on-remove="handleRemove"
      >
        <el-button size="small" type="primary">文件浏览</el-button>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureImport">确 定</el-button>
      </span>
    </el-dialog>
    <div class="heng"></div>

    <!-- 选择 -->
    <el-form inline :model="form" label-width="80px">
      <el-form-item label="升级类型">
        <el-select
          v-model="form.type"
          @change="inquireFile"
          placeholder="请选择类型"
          clearable
        >
          <el-option label="mcu" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文件" v-if="form.type">
        <el-select v-model="form.name" placeholder="请选择文件" clearable>
          <el-option
            v-for="(v, i) in files"
            :key="i"
            :label="v"
            :value="v"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          v-if="form.name"
          class="mgr-30 mgl-50"
          type="primary"
          @click="download"
          >下载</el-button
        >

        <el-button
          @click="upgradeBtn"
          v-if="form.name"
          class="mgr-30 mgl-50"
          type="primary"
          :disabled="btnDis"
          >升级</el-button
        >
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      stripe
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="futureBatchId" label="设备批次号">
      </el-table-column>
      <el-table-column prop="equipmentVersion" label="设备型号">
      </el-table-column>
      <el-table-column prop="equipmentNum" label="设备编号"> </el-table-column>
      <el-table-column prop="companyName" label="设备归属">
        <template slot-scope="scope">
          <span>
            {{ scope.row.companyName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="sceneName" label="铺设场景"> </el-table-column>
      <el-table-column prop="status" label="联网状态">
        <template slot-scope="scope">
          <span v-text="scope.row.status === 0 ? '离线' : '在线'"> </span>
        </template>
      </el-table-column>
      <el-table-column prop="error" label="设备状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.error == 0
                ? '正常'
                : scope.row.error == 1
                ? '异常'
                : '--'
            "
          >
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="equipmentSource" label="机器来源">
      </el-table-column>

      <el-table-column prop="createTime" label="添加时间"> </el-table-column>
      <el-table-column prop="futureProcessInfo" label="设备信息完整度">
      </el-table-column>
      <el-table-column prop="usingStatus" label="启用状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.usingStatus === 0
                ? '禁用'
                : scope.row.usingStatus === 1
                ? '启用'
                : ''
            "
          >
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="upgradeStatus" label="升级状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.upgradeStatus === 1
                ? '升级中'
                : scope.row.upgradeStatus === 10000
                ? '固件下载中'
                : scope.row.upgradeStatus === 11000
                ? '固件下载失败'
                : scope.row.upgradeStatus === 12000
                ? '固件下载成功'
                : scope.row.upgradeStatus === 20000
                ? '固件升级中'
                : scope.row.upgradeStatus === 22000
                ? '固件升级完成'
                : '- -'
            "
          >
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="upgradeVer" label="升级版本">
        <template slot-scope="scope">
          <span v-text="scope.row.upgradeVer ? scope.row.upgradeVer : '- -'">
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        type: "",
        name: "",
      },
      guishuArr: [], //设备归属下拉
      sceneArr: [],
      listForm: {},
      tableData: [],
      multipleSelection: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      typeListArr: [],

      fileList: [], //导入的文件列表
      importType: "",
      files: [], //文件
      btnDis: false,
      timer: null,
    };
  },
  created() {
    // this.getguishu();
    // this.getsceneList();
    this.getshebeiList();
    // this.getTypeList();
  },
  // beforeDestroy() {
  //   clearInterval(this.timer);
  // },
  methods: {
    // 升级按钮
    upgradeBtn() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条需要升级的设备", "error");
        return;
      }
      let sourceArr = [];
      this.multipleSelection.forEach((v) => {
        if (sourceArr.indexOf(v.equipmentSource) === -1) {
          sourceArr.push(v);
        }
      });
      if (sourceArr.length > 1) {
        handleAlert("请选择相同来源的设备", "error");
        return;
      }
      let upgradeArr = [];
      this.multipleSelection.forEach((v) => {
        upgradeArr.push({
          equipmentNum: v.equipmentNum,
          equipmentSource:
            v.equipmentSource == "未来先生"
              ? 1
              : v.equipmentSource == "未来先生一"
              ? 1
              : v.equipmentSource == "未来先生二"
              ? 3
              : "",
          type: this.form.type,
          fileName: this.form.name,
        });
      });
      handleConfirm(`确认升级此设备吗`, "info")
        .then(() => {
          this.btnDis = true;
          this.$api.upgrade.upgrade(upgradeArr).then((res) => {
            if (res.code === 200) {
              let timer = setInterval(() => {
                this.$api.upgrade
                  .upgradeStat({
                    equipmentNum: this.multipleSelection[0].equipmentNum,
                    type:
                      this.multipleSelection[0].equipmentSource == "未来先生"
                        ? 1
                        : this.multipleSelection[0].equipmentSource ==
                          "未来先生一"
                        ? 1
                        : this.multipleSelection[0].equipmentSource ==
                          "未来先生二"
                        ? 3
                        : "",
                  })
                  .then((res) => {
                    if (res.code === 200) {
                      if (res.data.code === "20000") {
                        handleAlert("固件升级中", "warning");
                      } else if (res.data.code === "10000") {
                        handleAlert("固件下载中", "warning");
                      } else if (res.data.code === "1") {
                        handleAlert("固件升级中", "warning");
                      } else if (res.data.code === "11000") {
                        handleAlert("固件下载失败", "error");
                        clearInterval(this.timer);
                        this.btnDis = false;
                      } else if (res.data.code === "12000") {
                        handleAlert("固件下载成功", "success");
                      } else if (res.data.code === "21000") {
                        handleAlert("固件升级失败", "error");
                        clearInterval(this.timer);
                        this.btnDis = false;
                      } else {
                        handleAlert("固件升级成功", "success");
                        this.getshebeiList();
                        clearInterval(timer);
                        this.btnDis = false;
                      }
                    }
                  });
              }, 3000);
              let _timer = timer;
              // clearInterval(_timer);
            }
          });
        })
        .catch(() => {
          return;
        });
    },

    // 查询文件列表
    inquireFile() {
      this.form.name = "";
      this.$api.upgrade.fileList({ type: this.form.type }).then((res) => {
        if (res.code === 200) {
          this.files = res.data;
        }
      });
    },
    // // 进度条
    // format(percentage) {
    //   return percentage === 100 ? "升级完成" : `${percentage}%`;
    // },
    // customColorMethod(percentage) {
    //   if (percentage < 100) {
    //     return "#e6a23c";
    //   } else {
    //     return "#67c23a";
    //   }
    // },
    // 下载
    download() {
      this.$api.upgrade
        .template({ name: this.form.name, type: this.form.type })
        .then((res) => {
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = URL.createObjectURL(res);
          link.setAttribute("download", this.form.name);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },

    import() {
      this.dialogVisible = true;
      this.importType = "";
    },

    // 导入弹框确认按钮
    sureImport() {
      if (this.importType == "") {
        handleAlert("请选择导入类型", "error");
        return;
      }
      if (this.fileList.length !== 1) {
        handleAlert("请导入文件", "error");
        return;
      }
      this.$refs.upload.submit();
    },

    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("file", params.file);
      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.upgrade
        .upload({
          file: formData,
          type: this.importType,
        })
        .then((res) => {
          if (res.code === 200) {
            this.dialogVisible = false;
            handleAlert("导入成功", "success");
            this.form = {
              type: "",
              name: "",
            };
          }
        });
      /* ------------------------------------ */

      // 成功失败都删除文件;
      this.fileList.splice(-1, 1);
    },
    /* 文件上传后的钩子  在此做校验 */
    fileChange(file, fileList) {
      this.file = file;
      // console.log(fileList);
      this.fileList = fileList;
      // let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      // if (extension !== "xlsx" && extension !== "xls") {
      //   this.$message.warning("只能上传后缀是.xlsx和xls的文件");
      //   fileList.splice(-1, 1); //移除错误文件
      //   return;
      // }
      // 文件大小校验
      const size = file.size / 1024 / 1024;
      if (size > 5) {
        this.$message.warning("文件大小不得超过5M");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      this.fileName = file.name;
    },
    /* 超出个数 */
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 导入的文件删除
    handleRemove(file, fileList) {
      console.log(file, fileList, "删除");
    },

    // 查询设备列表
    getshebeiList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.shebei
        .shebeiList({
          pageNum: this.page,
          pageSize: this.pageSize,
          equipmentVersion: this.listForm.equipmentVersion
            ? this.listForm.equipmentVersion
            : null,
          equipmentNum: this.listForm.equipmentNum
            ? this.listForm.equipmentNum
            : null,
          status: this.listForm.status ? this.listForm.status : null,
          startTime: this.listForm.startTime ? this.listForm.startTime : null,
          endTime: this.listForm.endTime ? this.listForm.endTime : null,
          futureCustomerId: this.listForm.companyName
            ? this.listForm.companyName
            : null,
          usingStatus: this.listForm.usingStatus
            ? this.listForm.usingStatus
            : null,
          error: this.listForm.error ? this.listForm.error : null,
          type: this.listForm.type ? this.listForm.type : null,
          futureBatchId: this.listForm.futureBatchId
            ? this.listForm.futureBatchId
            : null,
          equipmentSceneId: this.listForm.equipmentSceneId
            ? this.listForm.equipmentSceneId
            : null,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
    },
    getguishu() {
      this.$api.shebei.equipmentAffiliation().then((res) => {
        this.guishuArr = res.data;
      });
    },
    getTypeList() {
      this.$api.shebei.typeArr().then((res) => {
        if (res.code === 200) {
          this.typeListArr = res.data;
        }
      });
    },
    // 场景下拉
    getsceneList() {
      this.$api.shebei.sceneList().then((d) => {
        if (d.code === 200) {
          this.sceneArr = d.data;
        }
      });
    },
    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getshebeiList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getshebeiList(this.page);
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 重置
    reset() {
      this.listForm = {};
      this.getshebeiList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
